import * as store from '../transitions/transitions';

export const InvestAddOnSteps = [
	'invest-addon',
	'invest-esign',
	'invest-complete-addon',
];

export const InvestAddOnTransitions = {
	'invest-addon': [[store.hasSeenInvestValueProp, 'invest-esign']],
	'invest-esign': [[store.hasInvestEsig, 'invest-complete-addon']],
};

const InvestAddOnFlow = {
	name: 'InvestAddOnFlow',
	steps: InvestAddOnSteps,
	transitions: InvestAddOnTransitions,
	showProgressBarIcon: true,
};

export default InvestAddOnFlow;
